var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SelectorMediasQuery } from 'components/media/form/FormMediaSelector';
import { classNames } from 'libs/react';
import { useQuery } from 'libs/react';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { Text } from 'components/Text';
import { Icon } from 'components/Icon';
import { useModal } from 'components/modal/ModalStack';
import { MediaType } from 'libs/media/MediaType';
import './QuoteMedia.scss';
/**
 * @component QuoteMedia
 * @since 1.0.0
 */
export function QuoteMedia(props) {
    const { size, noLabel, style, title, infos, label, multiple, value } = Object.assign({ size: 'medium', style: 'normal' }, props);
    const modal = useModal();
    const [data] = useQuery(SelectorMediasQuery, {
        skip: value == null,
        variables: {
            selectedInput: {
                query: {
                    field: 'ids',
                    value: value,
                    operator: 'IN'
                }
            },
            input: {
                query: {
                    field: 'ids',
                    value: Array.isArray(value) ? value.join() : value,
                    operator: 'IN'
                }
            }
        }
    });
    const media = Array.isArray(data === null || data === void 0 ? void 0 : data.medias) ? data === null || data === void 0 ? void 0 : data.medias[0] : data === null || data === void 0 ? void 0 : data.medias;
    /**
     * @function onViewFile
     * @since 1.0.o
     * @hidden
     */
    const onViewFile = (value) => __awaiter(this, void 0, void 0, function* () {
        const isImage = MediaType.isImage(value.mimetype);
        const isPdf = MediaType.isFile(value.mimetype);
        modal.present({
            title: value.filename,
            picto: '',
            className: classNames('quote-media-modal', isImage ? 'quote-media-modal--image' : '', isPdf ? 'quote-media-modal--pdf' : ''),
            modal: (React.createElement("div", { className: "quote-media-modal-file" }, isImage ? (React.createElement("img", { src: value.url, alt: value.filename })) : (React.createElement("embed", { src: value.url, width: "100%", height: "100%" }))))
        });
    });
    if (value == null) {
        return null;
    }
    const className = classNames('quote-media', 'quote-media--' + style, props.className);
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: className },
            !noLabel && React.createElement(Text, { value: media === null || media === void 0 ? void 0 : media.filename }),
            React.createElement(Icon, { value: "file-pdf", onClick: () => {
                    media && onViewFile(media);
                } }))));
}
